import React, { useContext } from "react";
import "../styles/basketItemDiscount.css";
import "../styles/summary.css";
import { LanguageContext } from "../context/language/LanguageContext";
import appConst from "../Utilities/appConst.json";
import { useDispatch, useSelector } from "react-redux";
import { Info } from "lucide-react";
import { alertActions } from "../store/alertSlice";
import IconButton from "../shared/IconButton";

export default function UnavailableCoupon(props) {
  const languageContext = useContext(LanguageContext);
  const dispatch = useDispatch();
  const direction = useSelector((state) => state.mode.direction);
  const isRtl = direction === "rtl";

  const info = () => {
    dispatch(
      alertActions.createAlert({
        title: languageContext.getTranslation(appConst.COUPON_INFO_TITLE),
        message: props.coupon.terms_and_conditions,
        isDialog: false,
      })
    );
  };

  return (
    <div
      className="summary_coupon"
      style={{ display: "flex", justifyContent: isRtl ? "flex-end" : "flex-start" }}
    >
      <div className="summary_coupon_l summary_container">
        <div
          className="rtl_column_box_position message_coupon_main_text"
          style={{ direction, textAlign: "start" }}
        >
          <div
            style={{ display: "flex", alignItems: "center", columnGap: "0.35rem" }}
          >
            <IconButton
              className="summary-icon-btn p-0"
              style={{ flexShrink: 0, marginTop: "2px" }}
              data-testid="coupon-info-button"
              onClick={info}
            >
              <Info className="color_green" size={20} />
            </IconButton>
            <div>
              <div className="box_item_l bold disable">{props.coupon.coupon_title}</div>
              <div className="box_item_l warning_color">{props.coupon.message}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
